// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__-7Ix-","footer":"ModalCreateQualiphyProcedure_footer__3h_5C","additionData":"ModalCreateQualiphyProcedure_additionData__2Eg2l"};